// @formatter:off
/**
 * Kita-Scheduler
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// noinspection ES6UnusedImports
import {HttpClient, HttpContext, HttpEvent, HttpParams, HttpResponse} from '@angular/common/http';
import {Inject, Injectable, Optional} from '@angular/core';
import type {CheckInCustomFieldResourceCreateLinkedFieldCustomFieldIdMatrixParameter} from '@dv/shared/backend/model/check-in-custom-field-resource-create-linked-field-custom-field-id-matrix-parameter';
import type {CheckInCustomFieldResourceSetCheckInCustomFieldValuesValuesParameter} from '@dv/shared/backend/model/check-in-custom-field-resource-set-check-in-custom-field-values-values-parameter';
import type {EntityId} from '@dv/shared/backend/model/entity-id';
import type {JaxCheckInCustomFieldValuesUpdate} from '@dv/shared/backend/model/jax-check-in-custom-field-values-update';
import type {JaxCheckInCustomFields} from '@dv/shared/backend/model/jax-check-in-custom-fields';
import type {JaxIds} from '@dv/shared/backend/model/jax-ids';
import type {JaxKindCheckInCustomFieldValues} from '@dv/shared/backend/model/jax-kind-check-in-custom-field-values';
import {Observable} from 'rxjs';
import {BaseService} from '../api.base.service';
import {Configuration} from '../configuration';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS} from '../variables';

export interface CheckInCustomFieldApiCreateLinkedFieldRequestParams {
    customFieldId: EntityId;
    customFieldIdMatrix: CheckInCustomFieldResourceCreateLinkedFieldCustomFieldIdMatrixParameter;
}

export interface CheckInCustomFieldApiGetCustomFieldsForKinderRequestParams {
    values: CheckInCustomFieldResourceSetCheckInCustomFieldValuesValuesParameter;
    jaxIds: JaxIds;
}

export interface CheckInCustomFieldApiSetCheckInCustomFieldValuesRequestParams {
    kindId: EntityId;
    values: CheckInCustomFieldResourceSetCheckInCustomFieldValuesValuesParameter;
    jaxCheckInCustomFieldValuesUpdate: JaxCheckInCustomFieldValuesUpdate;
}

export interface CheckInCustomFieldApiUpdateCustomFieldsRequestParams {
    jaxCheckInCustomFields: JaxCheckInCustomFields;
}

@Injectable({
  providedIn: 'root'
})
export class CheckInCustomFieldApi extends BaseService {

    constructor(
        protected httpClient: HttpClient,
        @Optional() @Inject(BASE_PATH) basePath: string|string[],
        @Optional() configuration?: Configuration,
    ) {
        super(basePath, configuration);
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public createLinkedField$(requestParameters: CheckInCustomFieldApiCreateLinkedFieldRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public createLinkedField$(requestParameters: CheckInCustomFieldApiCreateLinkedFieldRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public createLinkedField$(requestParameters: CheckInCustomFieldApiCreateLinkedFieldRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public createLinkedField$(requestParameters: CheckInCustomFieldApiCreateLinkedFieldRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const customFieldId = requestParameters.customFieldId;
        if (customFieldId === null || customFieldId === undefined) {
            throw new Error('Required parameter customFieldId was null or undefined when calling createLinkedField$.');
        }
        const customFieldIdMatrix = requestParameters.customFieldIdMatrix;
        if (customFieldIdMatrix === null || customFieldIdMatrix === undefined) {
            throw new Error('Required parameter customFieldIdMatrix was null or undefined when calling createLinkedField$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/checkin/customfields/linked/${this.configuration.encodeParam({name: "customFieldId", value: customFieldId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}${this.configuration.encodeParam({name: "customFieldIdMatrix", value: customFieldIdMatrix, in: "path", style: "matrix", explode: true, dataType: "CheckInCustomFieldResourceCreateLinkedFieldCustomFieldIdMatrixParameter", dataFormat: undefined})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getCustomFields$(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JaxCheckInCustomFields>;
    public getCustomFields$(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JaxCheckInCustomFields>>;
    public getCustomFields$(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JaxCheckInCustomFields>>;
    public getCustomFields$(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/checkin/customfields`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<JaxCheckInCustomFields>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getCustomFieldsForKinder$(requestParameters: CheckInCustomFieldApiGetCustomFieldsForKinderRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JaxKindCheckInCustomFieldValues>;
    public getCustomFieldsForKinder$(requestParameters: CheckInCustomFieldApiGetCustomFieldsForKinderRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JaxKindCheckInCustomFieldValues>>;
    public getCustomFieldsForKinder$(requestParameters: CheckInCustomFieldApiGetCustomFieldsForKinderRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JaxKindCheckInCustomFieldValues>>;
    public getCustomFieldsForKinder$(requestParameters: CheckInCustomFieldApiGetCustomFieldsForKinderRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const values = requestParameters.values;
        if (values === null || values === undefined) {
            throw new Error('Required parameter values was null or undefined when calling getCustomFieldsForKinder$.');
        }
        const jaxIds = requestParameters.jaxIds;
        if (jaxIds === null || jaxIds === undefined) {
            throw new Error('Required parameter jaxIds was null or undefined when calling getCustomFieldsForKinder$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/checkin/customfields/values${this.configuration.encodeParam({name: "values", value: values, in: "path", style: "matrix", explode: true, dataType: "CheckInCustomFieldResourceSetCheckInCustomFieldValuesValuesParameter", dataFormat: undefined})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<JaxKindCheckInCustomFieldValues>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: jaxIds,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public setCheckInCustomFieldValues$(requestParameters: CheckInCustomFieldApiSetCheckInCustomFieldValuesRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public setCheckInCustomFieldValues$(requestParameters: CheckInCustomFieldApiSetCheckInCustomFieldValuesRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public setCheckInCustomFieldValues$(requestParameters: CheckInCustomFieldApiSetCheckInCustomFieldValuesRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public setCheckInCustomFieldValues$(requestParameters: CheckInCustomFieldApiSetCheckInCustomFieldValuesRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const kindId = requestParameters.kindId;
        if (kindId === null || kindId === undefined) {
            throw new Error('Required parameter kindId was null or undefined when calling setCheckInCustomFieldValues$.');
        }
        const values = requestParameters.values;
        if (values === null || values === undefined) {
            throw new Error('Required parameter values was null or undefined when calling setCheckInCustomFieldValues$.');
        }
        const jaxCheckInCustomFieldValuesUpdate = requestParameters.jaxCheckInCustomFieldValuesUpdate;
        if (jaxCheckInCustomFieldValuesUpdate === null || jaxCheckInCustomFieldValuesUpdate === undefined) {
            throw new Error('Required parameter jaxCheckInCustomFieldValuesUpdate was null or undefined when calling setCheckInCustomFieldValues$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/checkin/customfields/kind/${this.configuration.encodeParam({name: "kindId", value: kindId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/values${this.configuration.encodeParam({name: "values", value: values, in: "path", style: "matrix", explode: true, dataType: "CheckInCustomFieldResourceSetCheckInCustomFieldValuesValuesParameter", dataFormat: undefined})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: jaxCheckInCustomFieldValuesUpdate,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public updateCustomFields$(requestParameters: CheckInCustomFieldApiUpdateCustomFieldsRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public updateCustomFields$(requestParameters: CheckInCustomFieldApiUpdateCustomFieldsRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public updateCustomFields$(requestParameters: CheckInCustomFieldApiUpdateCustomFieldsRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public updateCustomFields$(requestParameters: CheckInCustomFieldApiUpdateCustomFieldsRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const jaxCheckInCustomFields = requestParameters.jaxCheckInCustomFields;
        if (jaxCheckInCustomFields === null || jaxCheckInCustomFields === undefined) {
            throw new Error('Required parameter jaxCheckInCustomFields was null or undefined when calling updateCustomFields$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/checkin/customfields`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: jaxCheckInCustomFields,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
// @formatter:on
